import axios from "axios";

export function editAcls(data) {
  let accountId = data.accountId;
  let configAccount = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/eaa/eaa-shops/${accountId}/acls`,
    data: data
  };

  return axios(configAccount);
}

export function createPromotion(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/eaa/shops/${data.businessId}/promotions`,
    data: data
  };
  return axios(config);
}

export function promotionSetting(data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/eaa/shops/${data.businessId}/promotions/${data.id}/setting`,
    data: {data}
  };
  return axios(config);
}